import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BackendAPI } from "@app/core/models/backend-api";
import { ContactDetailsPersistentModel } from "@app/shared/models/contact-details-persistent-model";
import { Observable } from "rxjs";

@Injectable({
	providedIn: 'root'
})
export class UserService {

	constructor (private http: HttpClient) {
	}

	registerUser(contactDetails: ContactDetailsPersistentModel): Observable<string> {
		return this.http.post<string>(BackendAPI.registerUser, contactDetails);
	}

	activateUser(email: String, verificationCode: String, password: String): Observable<void> {
		const activationModel = {
			email: email,
			verification: verificationCode,
			password: password
		}
		return this.http.post<void>(BackendAPI.activateUser, activationModel);
	}

	forgotPassword(emailAddress: String): Observable<void> {
		return this.http.post<void>(BackendAPI.forgotPassword, emailAddress);
	}

	resetPassword(email: string, verificationCode: string, password: string): Observable<void> {
		const request = {
			email: email,
			verification: verificationCode,
			password: password
		}

		return this.http.post<void>(BackendAPI.resetPassword, request);
	}
}
